// Amplify
import amplifyconfig from "../../amplifyconfiguration.json";
import { parseAmplifyConfig } from "aws-amplify/utils";

export const primaryAmplifyConfig = parseAmplifyConfig(amplifyconfig);
